// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1pUif","tab":"Tabs_tab__3_wWT","tabActive":"Tabs_tabActive__RH_s2"};